import { createFileRoute, redirect } from "@tanstack/react-router";

import { m } from "@/paraglide/messages.js";

/** Trainings are reached from a visit or a client's page; the bare address goes to the schedule. */
export const Route = createFileRoute("/(private)/booking/trainings/")({
  beforeLoad: () => {
    throw redirect({ to: "/booking" });
  },
  loader: () => ({ crumb: m.coached_training_crumb_list() }),
});
